import { gql } from "@apollo/client";

export const GET_ALL_TIPO_PROFESIONALES = gql`
query GetAllTipoProfesional {
    allTipoProfesional{
            idTipoProfesional,
            descripcion
        }
}`;